import React from 'react';
import { Form, Input, Row, Col, Select, Modal, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from 'utils/dateFormat';

const UpdateDeviceModal = (props) => {
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const { t } = useTranslation();

  const onFinish = (values) => {
    console.log('Received values:', values);
    props.action(values);
    props.close();
  };

  const setConfig = () => {
    let flag = props.selectedDevice.CONFIG_SWITCH;
    flag = flag === 0 ? 1 : 0;
    props.setDeviceConfig(props.selectedDevice.MAC, flag);
  };

  return (
    <Modal
      title={t("DevicePage.updateDevice")}
      open={true}
      onOk={() => form.submit()}
      onCancel={props.close}
    >
      <Form
        form={form}
        onFinish={onFinish}
        initialValues={props.selectedDevice}
        layout="vertical"
      >
        <p>{t("DevicePage.table.id")}: <span style={{ fontWeight: 'bold' }}>{props.selectedDevice ? props.selectedDevice.Id : ''}</span></p>
        <p>{t("DevicePage.deviceModal.lastModified")}: <span style={{ fontWeight: 'bold' }}>
          {props.selectedDevice
            ? formatDateTime(props.selectedDevice["LAST DATA"])
            : ''}
        </span></p>

        <Row gutter={16}>
          <Col span={24} lg={8}>
            <Form.Item
              label={t("DevicePage.deviceModal.macAddress")}
              name="MAC"
              rules={[{ required: true, message: t("DevicePage.deviceModal.macAddressRequired") }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24} lg={8}>
            <Form.Item
              label={t("DevicePage.deviceModal.name")}
              name="NAME"
              rules={[{ required: true, message: t("DevicePage.deviceModal.nameRequired") }]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={24} lg={8} />

          <Col span={24} lg={8}>
            <Form.Item
              label={t("DevicePage.deviceModal.positionX")}
              name="DEPLOY_X"
              rules={[{ required: true, message: t("DevicePage.deviceModal.positionXRequired") }]}
            >
              <Input type="number" />
            </Form.Item>
          </Col>
          <Col span={24} lg={8}>
            <Form.Item
              label={t("DevicePage.deviceModal.positionY")}
              name="DEPLOY_Y"
              rules={[{ required: true, message: t("DevicePage.deviceModal.positionYRequired") }]}
            >
              <Input type="number" />
            </Form.Item>
          </Col>
          <Col span={24} lg={8}>
            <Form.Item
              label={t("DevicePage.deviceModal.positionZ")}
              name="DEPLOY_Z"
              rules={[{ required: true, message: t("DevicePage.deviceModal.positionYRequired") }]}
            >
              <Input type="number" />
            </Form.Item>
          </Col>

          <Col span={24} lg={8}>
            <Form.Item
              label={t("DevicePage.deviceModal.rotationX")}
              name="ROT_X"
              rules={[{ required: true, message: t("DevicePage.deviceModal.rotationXRequired") }]}
            >
              <Input type="number" />
            </Form.Item>
          </Col>
          <Col span={24} lg={8}>
            <Form.Item
              label={t("DevicePage.deviceModal.rotationY")}
              name="ROT_Y"
              rules={[{ required: true, message: t("DevicePage.deviceModal.rotationYRequired") }]}
            >
              <Input type="number" />
            </Form.Item>
          </Col>
          <Col span={24} lg={8}>
            <Form.Item
              label={t("DevicePage.deviceModal.rotationZ")}
              name="ROT_Z"
              rules={[{ required: true, message: t("DevicePage.deviceModal.rotationZRequired") }]}
            >
              <Input type="number" />
            </Form.Item>
          </Col>

          <Col span={24} lg={12}>
            <Form.Item
              label={t("DevicePage.deviceModal.location")}
              name="ROOM_NAME"
              rules={[{ required: true, message: t("DevicePage.deviceModal.locationRequired") }]}
            >
              <Select options={props.suggestions} placeholder={t("DevicePage.deviceModal.locationPlaceholder")} />
            </Form.Item>
          </Col>
          <Col span={24} lg={12}>
            <Form.Item
              label={t("DevicePage.deviceModal.type")}
              name="TYPE"
              rules={[{ required: true, message: t("DevicePage.deviceModal.typeRequired") }]}
            >
              <Select>
                <Select.Option value="1">{t("deviceType.cliff")}</Select.Option>
                <Select.Option value="2">{t("deviceType.ceil")}</Select.Option>
                <Select.Option value="3">{t("deviceType.vibs")}</Select.Option>
                <Select.Option value="4">{t("deviceType.alarm")}</Select.Option>
                <Select.Option value="5">{t("deviceType.lidar")}</Select.Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label={t("DevicePage.deviceModal.description")}
              name="DESCRIPTION"
              rules={[{ required: true, message: t("DevicePage.deviceModal.descriptionRequired") }]}
            >
              <TextArea />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Button type="primary" size="large" onClick={setConfig}>
              {props.selectedDevice.CONFIG_SWITCH === 0
                ? t("DevicePage.deviceModal.turnOnConfig")
                : t("DevicePage.deviceModal.turnOffConfig")}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default UpdateDeviceModal;
